define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var ViewController = require('web-agent-framework/ViewController');

    var TagViewController = ViewController.extend({
        ControllerName: 'TagViewController',

        LPViewMap: {
            tag_close_button: ".lpview_tag_close_button",
            tag_text: ".lpview_tag_text"
        },
        initialize: function (constructorData) {
            this.tagText = constructorData.tagText;
            this.tagValue = constructorData.tagValue ? constructorData.tagValue : constructorData.tagText;
            this.context = constructorData.context;
            this.closeCallback = constructorData.closeCallback;
            this.initializeView();
        },

        events: function () {
            this.bindViewEvent({selector: this.LPViewMap.tag_close_button, DOMEvent: "click", callback: this.buttonClicked});
        },
        render: function () {

        }
    });

    TagViewController.prototype.initializeView = function () {
        var tableTemplate = require("web-agent-templates/LP_tag_view.html");
        // var tableTemplate = lpUtils.loadResource("web-agent-templates/LP_tag_view.html");
        var textInjection = {
            text: this.tagText
        };
        tableTemplate = this.injectTextDefaults(tableTemplate, textInjection);
        this.view = this.createView({template: tableTemplate});
    };

    TagViewController.prototype.buttonClicked = function () {
        this.lpHide();
        this.closeCallback.call(this.context, this.tagValue);
    };

    return TagViewController;

});
